import './scroll-snap-indicators.scss';

const DEFAULTS = {
  carousel: '.js-carousel',
  indicator: '.js-carousel-indicator',
  slides: '.js-carousel-item'
};
let currentIndex = 0;

export function scrollSnapIndicators(opts = {}, context: HTMLElement | Document = document) {
  let options = Object.assign(DEFAULTS, opts);
  let carousel = context.querySelector(options.carousel);

  if (!carousel) return;

  let indicator = context.querySelector(options.indicator);
  let elements = carousel.querySelectorAll(options.slides);

  if (elements.length === 1) return;

  let observer = new IntersectionObserver(
    (entries, observer) => {
      let activated = entries.reduce((max, entry) => (entry.intersectionRatio > max.intersectionRatio ? entry : max));
      if (activated.intersectionRatio > 0) {
        currentIndex = elementIndices[activated.target.getAttribute('data-slide')];
        if (indicator) {
          renderIndicator(indicator, elements);
        }
      }
    },
    {
      root: carousel,
      threshold: 0.5
    }
  );

  let elementIndices = {};
  for (var i = 0; i < elements.length; i++) {
    elementIndices[elements[i].getAttribute('data-slide')] = i;
    observer.observe(elements[i]);
  }
}

function renderIndicator(indicator, elements) {
  indicator.innerHTML = '';
  for (let i = 0; i < elements.length; i++) {
    let el = document.createElement('span');
    if (i === currentIndex) el.classList.add('current');
    (function (i) {
      el.onclick = () => elements[i].scrollIntoView({ behavior: 'smooth' });
    })(i);
    indicator.appendChild(el);
  }
}
